import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['kg'] as const;

const validator = AbstractMeasurement.value.extend({
    unit: z.enum(units).default('kg'),
});

export const Weight = {
    validator,
    units,
};
